// @flow
/**
 * Created by Mike Chung on 2/27/18.
 */
import React from "react";
import * as _ from "lodash";

type TableRowProps = {
    className?: string
}

export default function TableRow(props: TableRowProps) {
    const {className, ...rest} = props;
    let clazz = `divTableRow ${_.defaultTo(className, "")}`;
    return (
        <div className={clazz} {...rest} />
    );
}


// WEBPACK FOOTER //
// ./src/components/util/tables/TableRow.js